import '../../App.css'
import { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import { useNavigate } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit, faEye } from '@fortawesome/free-solid-svg-icons'
import { AppContextMenu } from '../../App'

function filterDeletedItems(data) {
    return data.filter((item) => {
        const positionDeleted = item.position?.is_deleted
        const departmentDeleted = item.department?.is_deleted
        return !positionDeleted && !departmentDeleted
    })
}

function FurloughRoutes() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furloughRoutes')
    }, [])

    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState([])
    let navigate = useNavigate()

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-routes`,
            },
            resolve: (res) => {
                setDataGet(filterDeletedItems(res.data))
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box w-full">
                        <div className="w-full px-4 py-8">
                            <div className="bg-white w-full rounded-xl shadow-sm  border border-gray-100">
                                {/* Header - Fixed Desktop Style */}
                                <div className="px-6 py-5 border-b rounded-xl border-gray-200 flex maxLg:flex-col justify-between items-center bg-gradient-to-r from-purple-100 to-indigo-500">
                                    <h2 className="text-2xl font-semibold text-white">
                                        لیست مسیر مرخصی ها
                                    </h2>
                                    <button
                                        className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg text-white px-5 py-2.5 rounded-lg duration-300 transform hover:-translate-y-0.5 flex items-center gap-2"
                                        onClick={() =>
                                            navigate('/furloughRoutesAdd')
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            className="text-white"
                                        />
                                        <span>افزودن</span>
                                    </button>
                                </div>

                                {/* Table Container */}
                                <div className="overflow-x-auto w-full">
                                    <div
                                        className="w-full"
                                        style={{ minWidth: '100%' }}
                                    >
                                        <table className="w-full divide-y divide-gray-200">
                                            {/* Table Header */}
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    {RequestQueue.getAuthResult()
                                                        ?.user?.role?.name ===
                                                        'superAdmin' && (
                                                        <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                            سازمان
                                                        </th>
                                                    )}

                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        بخش کاری
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        جایگاه شغلی
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        ویرایش
                                                    </th>
                                                </tr>
                                            </thead>

                                            {/* Table Body */}
                                            <tbody className="bg-white divide-y divide-gray-100">
                                                {dataGet.map((d) => (
                                                    <tr
                                                        key={d.id}
                                                        className="group transition-all duration-300 hover:bg-gradient-to-r hover:to-indigo-100 hover:via-white hover:from-purple-100"
                                                    >
                                                        {RequestQueue.getAuthResult()
                                                            ?.user?.role
                                                            ?.name ===
                                                            'superAdmin' && (
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <div className="text-sm text-gray-900">
                                                                    {
                                                                        d
                                                                            .organization
                                                                            ?.name
                                                                    }
                                                                </div>
                                                            </td>
                                                        )}

                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="text-sm text-gray-900">
                                                                {
                                                                    d.position
                                                                        .name
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="text-sm text-gray-900">
                                                                {
                                                                    d.department
                                                                        .name
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                            <div className="flex justify-center">
                                                                <button
                                                                    className="text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-4 py-2 rounded-lg transition-colors duration-200 flex items-center"
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/furloughRoutesEdit/${d.id}`
                                                                        )
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faEye
                                                                        }
                                                                        className="ml-2"
                                                                    />
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faEdit
                                                                        }
                                                                        className="ml-2"
                                                                    />
                                                                    مشاهده و
                                                                    ویرایش
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default FurloughRoutes
